import React, { memo } from 'react';

interface CustomBannerProps {
  value: number;
  title: string;
  imageUrl?: string;
}

const CustomBanner: React.FC<CustomBannerProps> = ({
  value,
  title,
  imageUrl = require('src/assets/png/pointLogo.png')
}) => {
  const formattedValue = value.toLocaleString('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    style: 'decimal'
  });

  return (
    <div className="bg-highlight-decent min-width-300 display-flex flex-column align-items-center justify-content-center padding-y-32">
      <div className="display-flex flex-column align-items-center justify-content-center gap-16">
        <div className="display-flex flex-column align-items-center gap-8">
          <span className="text-size-17 text-bold text-color-status-resting">{title}</span>
          <div className="display-flex flex-row align-items-center gap-8">
            <div className="display-flex flex-row align-items-end justify-content-end height-70pct margin-x-5">
              <img src={imageUrl} alt="logo" className="width-90pct" />
            </div>
            <div className="display-flex flex-row align-items-baseline gap-8">
              <span className="text-size-h1 text-bold text-color-rating-4">
                {formattedValue}
              </span>
              <span className="text-size-h5 text-bold text-color-rating-4">
                pontos
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CustomBanner);